import script from "./ChatShareModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatShareModal.vue?vue&type=script&setup=true&lang=js"

import "./ChatShareModal.vue?vue&type=style&index=0&id=31af680e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31af680e"]])

export default __exports__